import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import moment from "moment";
import { Modal } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import dayjs from "dayjs";
class LiveTrackingStore {
  liveTrackingData = [];
  totalvehstate = [];
  total = 0;
  loading = false;
  rootStore;
  selectedTab;
  timer = 30;
  pgcount = 1;
  offset = 0;
  LatLongDistArray = [];
  TotalDistance = undefined;
  TotalTime = undefined;
  selectedAdrressArray = [];
  AutorunVar = false;
  AutorunPopup = false;
  LatLongArray = [];
  error = false;
  showNearVehiclePopup = false;
  totalCount = null;
  veicleList = [];
  GeofenceList = [];
  NearVeicleList = [];
  MapClickPoints = [];
  stopIdleArray = [];
  offlineDataNewObj = [];
  vehiclesArray = [];
  vehiclePositionArray = [];
  vehiclePositionData = [];

  vehiclePosition = [];
  Marker = undefined;

  geofenceListArray = [];
  getSelectedGroups = [];
  selectedVehicles = [];
  vehicleTrackingInfo = [];
  selectedVehicles1 = [];
  daySummaryObj = {};
  driverPerformanceData = {};

  plotAllVehicles = [];
  poiData = []
  constructor(rootStore) {
    makeObservable(this, {
      liveTrackingData: observable,
      totalvehstate: observable,
      driverPerformanceData: observable,
      total: observable,
      loading: observable,
      timer: observable,
      LatLongDistArray: observable,
      TotalDistance: observable,
      TotalTime: observable,
      selectedAdrressArray: observable,
      AutorunVar: observable,
      AutorunPopup: observable,
      LatLongArray: observable,
      showNearVehiclePopup: observable,
      veicleList: observable,
      GeofenceList: observable,
      NearVeicleList: observable,
      MapClickPoints: observable,
      selectedVehicles: observable,
      selectedVehicles1: observable,
      daySummaryObj: observable,
      vehicleTrackingInfo: observable,
      getSelectedGroups: observable,
      vehiclesArray: observable,
      vehiclePositionArray: observable,
      vehiclePositionData: observable,
      Marker: observable,
      offlineDataNewObj: observable,
      geofenceListArray: observable,
      stopIdleArray: observable,
      vehiclePosition: observable,
      totalCount: observable,
      plotAllVehicles: observable,
      poiData: observable,
      daySummary: action,
      addPoiData: action,
      loadData: action,
      setDistLatLong: action,
      // getDistance: action,
      // toRadian: action,
      GetLocationAddress: action,
      setAutorunVar: action,
      RemoveDistData: action,
      updateSelectedAdrressArray: action,
      setLatLongDistArray: action,
      AddSelectedAdrressArray: action,
      setShowNearVehiclePopup: action,
      getVehicleData: action,
      getNearestVehicleServ: action,

      setOnMapClickPoints: action,

      getVehiclesUsingCompanyId: action,
      getAddressUsingLatLong: action,

      setAutorunPopup: action,
      setMarker: action,

      getGofenceList: action,
      getIcon: action,

      sampleExcel: action,
      addGeofenceByExcel: action,
      getTypeData: action,
      exportPoiVehicle: action,
      getClusterVehicleData: action,
      getDriverPerformance: action,
      getVehicleTrackingInfo: action,

      getVehiclePositionofVehicle: action,
      getAllVehicles: action,
      showAllPois: action,
      searchPoiData: action,

      deletePoiData: action,
      addPOIByExcel: action
    });
    this.rootStore = rootStore;
  }

  async addData({ jTypeName }) {
    var postData = { jobType: { jTypeName: jTypeName } };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=delivery&a=addJobtype", "postData=" + base64Input);
  }

  async getVehicleTrackingInfo({ vehicleId, companyId }) {
    var postData = { vehicleId: vehicleId, companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=getvehicleposition",
        "postData=" + base64Input
      );
    this.vehicleTrackingInfo = response?.data;

    return response?.data?.data?.vehicleposition[0];
  }

  async handleVehicleImageCH(data) {
    let liveTrackingData = data;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];
      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (r.vehicleStatus === "nodata") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.vehicleStatus === "idle") {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.vehicleStatus === "stop") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.vehicleStatus === "running") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }

  async handleVehicleImage(data) {
    let liveTrackingData = data;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");

      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (diff >= 90) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.acc == 0 ||
        r.acc == "NAA" ||
        r.acc == "NA" ||
        r.acc === null) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.acc == null || (r.acc == 1 && r.speed > 0)) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }

  async loadData({
    companyId,
    poupSearch,
    vehicleStatus,
    value,
    offset,
    limit,
    addPreviousVehicles,
    selectedVehicleId,
  }) {
    this.loading = true;
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    let userCompanyId = JSON.parse(
      base64_decode(Cookies.get("data"))
    ).userCompanyId;

    let userId = JSON.parse(base64_decode(Cookies.get("data"))).userId;

    var postData = {
      companyId: isadmin == 1 || 0 ? userCompanyId : companyId,
      userId: userId,
      isadmin: isadmin,
      status: "searchvod",
      poupSearch: poupSearch,
      vehicleStatus: vehicleStatus,
      vehicleIds: value,
      selectedVehicleIds: selectedVehicleId,
      offset: offset,
      limit: limit,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

    if (config.project === "proawtltrack") {
      var response = await postApi
        // .getClient("NodeCoreUrl")
        // .get("/liveTracking/getData", { params: postData });
        .getClient("report")
        // .get("http://localhost:3053/liveTracking/getDatabyCH", {
        .get("/liveTracking/getDatabyCH", {
          params: {
            companyId: isadmin == 1 || 0 ? userCompanyId : companyId,
            userId: userId,
            isadmin: isadmin,
            status: "searchvod",
            poupSearch: poupSearch,
            vehicleStatus: vehicleStatus,
            vehicleIds: value,
            offset: offset,
            limit: limit,
            selectedVehicleIds: selectedVehicleId,
          },
        });

      var liveTrackingData = response?.data?.data?.livetrack;

      this.totalCount = response?.data?.data?.TotalCount;
      let finalLiveTrackingData = await this.handleVehicleImageCH(liveTrackingData);

      if (addPreviousVehicles) {
        this.liveTrackingData = [
          ...this.liveTrackingData,
          ...finalLiveTrackingData,
        ];
      } else {
        this.liveTrackingData = [];
        this.liveTrackingData = finalLiveTrackingData;
      }
      // this.liveTrackingData=this.getSelectedGroups;
      this.totalvehstate = response?.data?.data?.totalvehstate;
      this.loading = false;
      if (this.selectedVehicles) {
        let updatedInfo = this.selectedVehicles.map((recordInfo) => {
          let matchingRecordA = this.liveTrackingData.find(
            (recordA) => recordA.vehicleId === recordInfo.vehicleId
          );
          if (matchingRecordA) {
            for (let prop in matchingRecordA) {
              recordInfo[prop] = matchingRecordA[prop];
            }
          }
          return recordInfo;
        });
        this.selectedVehicles = updatedInfo;
      }
    } else {
      var response = await postApi
        .getClient()
        // .get("http://localhost:3053/liveTracking/getData", { params: postData });
        .get(config.NodeUrl + "/liveTracking/getData", { params: postData });


      var liveTrackingData = response?.data?.data?.livetrack;

      this.totalCount = response?.data?.data?.TotalCount;
      let finalLiveTrackingData = await this.handleVehicleImage(liveTrackingData);

      if (addPreviousVehicles) {
        this.liveTrackingData = [
          ...this.liveTrackingData,
          ...finalLiveTrackingData,
        ];
      } else {
        this.liveTrackingData = [];
        this.liveTrackingData = finalLiveTrackingData;
      }
      // this.liveTrackingData=this.getSelectedGroups;
      this.totalvehstate = response?.data?.data?.totalvehstate;
      this.loading = false;
      if (this.selectedVehicles) {
        let updatedInfo = this.selectedVehicles.map((recordInfo) => {
          let matchingRecordA = this.liveTrackingData.find(
            (recordA) => recordA.vehicleId === recordInfo.vehicleId
          );
          if (matchingRecordA) {
            for (let prop in matchingRecordA) {
              recordInfo[prop] = matchingRecordA[prop];
            }
          }
          return recordInfo;
        });
        this.selectedVehicles = updatedInfo;
      }
    }
  }

  async getDriverPerformance(data) {
    if (config.pythonReport === 1) {
      var postData = {
        companyId: data.companyId,
        driverId: [data.driverId],
        fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
        toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        offset: 0,
        limit: 50,
        page: 1,
        last_record_timestamp: "",
        remaning_driverId: "",
      };
      var response = await postApi
        .getClient("report")
        .post("driver_report/driverperformance", postData);
    } else {
      var postData = data;
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=getDriverPerformance",
          "postData=" + base64Input
        );
    }
    this.driverPerformanceData = response.data?.data;
    return response?.data?.data;
  }

  async getClusterVehicleData(data) {
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=clusterVehicleData",
        "postData=" + base64Input
      );

    return response?.data?.data;
  }

  async GetLocationAddress(data) {
    // var data = {};
    //  data.latitude = parseFloat(d.lat);
    //  data.longitude = parseFloat(d.lng);
    const base64Input = await base64_encode(JSON.stringify(data));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=liveLocation&a=getLocation",
        "postData=" + base64Input
      );
    this.selectedAddress = response.data.data.display_name;
    this.selectedAdrressArray.push(this.selectedAddress);
    this.AutorunVar = true;
  }
  async setDistLatLong(data) {
    this.LatLongArray = data;
    var totalDists = 0;
    var traveltotalTime = 0;
    if (data.length > 1) {
      for (var i = 0; i < data.length - 1; i++) {
        // var first = data[data.length - 2];
        // var next = data[data.length - 1];

        var first = data[i];
        var next = data[i + 1];

        await fetch(
          "https://maps.googleapis.com/maps/api/distancematrix/json?key=AIzaSyAYh_6XQRV70kMX2LdZ9B1fd4qOhTgvfIo-zlr8VM&origins=" +
          first.lat +
          "," +
          first.lng +
          "&destinations=" +
          next.lat +
          "," +
          next.lng
        )
          .then((res) => res.json())
          .then((resdata) => {
            // var distance = (data.rows[0].elements[0].distance.text.split(" "));
            var distance = resdata.rows[0].elements[0].distance.value;
            var time = resdata.rows[0].elements[0].duration.value;
            var responseData = { distance: distance, time: time };
            this.LatLongDistArray.push(responseData);
            // this.GetLocationAddress(this.LatLongArray[this.LatLongArray.length-1]);
          })
          .catch((err) => {
            // if(i == data.length){
            Modal.warning({
              title: "Alert",
              content: "Please Try After Sometime",
            });
            // }

            this.error = true;
          });
      }
    }

    if (this.LatLongDistArray) {
      this.LatLongDistArray.map((l) => {
        totalDists += l.distance;
        traveltotalTime += l.time;
      });
      this.TotalDistance = parseFloat((totalDists / 1000).toFixed(2));
      this.TotalTime = parseFloat((traveltotalTime / 60).toFixed(2));

      this.AutorunVar = true;
    }
  }

  setAutorunVar(data) {
    this.AutorunVar = data;
  }
  RemoveDistData() {
    this.selectedAdrressArray = [];
    this.TotalDistance = undefined;
    this.TotalTime = undefined;
    this.LatLongDistArray = [];
    this.LatLongArray = [];
  }
  async updateSelectedAdrressArray(i) {
    var selectedAdrressArray = [];
    var LatLongArray = [];
    var delIndex = i;
    selectedAdrressArray = this.selectedAdrressArray.filter((e, index) => {
      return index != delIndex;
    });
    this.selectedAdrressArray = selectedAdrressArray;
    // this.AutorunVar = true;

    LatLongArray = this.LatLongArray.filter((m, ind) => {
      return ind != delIndex;
    });
    this.LatLongArray = LatLongArray;
    this.TotalDistance = undefined;
    this.TotalTime = undefined;
    this.LatLongDistArray = [];
    this.setDistLatLong(this.LatLongArray);
  }
  setLatLongDistArray() {
    this.LatLongDistArray = [];
  }
  AddSelectedAdrressArray(data) {
    var selectedAdrressArray = [];
    selectedAdrressArray = this.selectedAdrressArray.filter((e, index) => {
      return index != data;
    });
    this.selectedAdrressArray = selectedAdrressArray;
  }
  setShowNearVehiclePopup(data) {
    this.showNearVehiclePopup = data;
  }

  async getVehicleData(id) {
    var data = {};
    data.companyId = id;

    const base64Input = await base64_encode(JSON.stringify(data));
    var response = await postApi
      .getClient()
      .post("index.php?c=trip&a=getvehicledata", "postData=" + base64Input);
    this.veicleList = response.data.data.vehicles;
    this.GeofenceList = response.data.data.geofences;
    // this.selectedAdrressArray.push(this.selectedAddress);
    // this.AutorunVar = true;
  }
  async getNearestVehicleServ(data) {
    const base64Input = await base64_encode(JSON.stringify(data));
    var response = await postApi
      .getClient()
      .post("index.php?c=trip&a=nearestvehicle", "postData=" + base64Input);
    this.NearVeicleList = response.data.data;

    let liveTrackingData = response.data.data;
    let finalLiveTrackingData = await this.handleVehicleImage(liveTrackingData);

    this.NearVeicleList = finalLiveTrackingData;

    return this.NearVeicleList;
  }

  // setOnMapClickPoints(data1,data2){
  // this.MapClickPoints[0] = data1;
  // this.MapClickPoints[1] = data2;
  // }

  setOnMapClickPoints(data) {
    this.MapClickPoints = data;
  }

  async getVehiclesUsingCompanyId({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    this.vehiclesArray = response.data.data;
  }

  async poiCurrentVehicleUsingCompanyId({ companyId }) {
    let response
    if (config.pythonReport == 1) {
      response = await postApi
        .getClient()
        .get(config.NodeUrl + "/pointOfInterest/poiCurrentVehicle", {
          params: {
            companyId: companyId,
          }
        });

      this.vehiclePositionArray = response.data.data;
    } else {
      var postData = { companyId: companyId };
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post("index.php?c=poi&a=poiCurrentVehicle", "postData=" + base64Input);

      this.vehiclePositionArray = response.data.data;
    }

  }

  getAddressUsingLatLong = (shapeType, centerLat, centerLng, radius) => {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        return reject("Google Maps JS API not loaded");
      }

      const geocoder = new window.google.maps.Geocoder();

      let location = { lat: centerLat, lng: centerLng };

      // For now, all shapes resolve using center point
      // (Geocoder works with a single lat/lng, not full shapes)
      if (shapeType === "circle") {
        location = { lat: centerLat, lng: centerLng };
      } else if (shapeType === "polygon") {
        location = { lat: centerLat, lng: centerLng };
      } else if (shapeType === "rectangle") {
        location = { lat: centerLat, lng: centerLng };
      }

      geocoder.geocode({ location }, (results, status) => {
        if (status === "OK" && results && results.length > 0) {
          resolve(results[0].formatted_address);
        } else {
          console.error("Geocode failed:", status);
          resolve(null);
        }
      });
    });
  };

  // async getAddressUsingLatLong(shapeType, centerLat, centerLng, radius) {
  //   const apiKey = "AIzaSyAYh_6XQRV70kMX2LdZ9B1fd4qOhTgvfIo";
  //   let url;

  //   if (shapeType === "circle") {
  //     url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${centerLat},${centerLng}&key=${apiKey}`;
  //   } else if (shapeType === "polygon") {
  //     // For polygons, you can pass multiple lat/lng pairs as path parameter
  //     const path = `${centerLat},${centerLng}`;
  //     // url = `https://maps.googleapis.com/maps/api/geocode/json?path=${path}&key=${apiKey}`;
  //     url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${centerLat},${centerLng}&key=${apiKey}`;
  //   } else if (shapeType === "rectangle") {
  //     // For rectangles (square is a type of rectangle), you can use the center lat/lng directly
  //     url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${centerLat},${centerLng}&key=${apiKey}`;
  //   }

  //   const response = await fetch(url);
  //   const data = await response.json();

  //   if (data.status === "OK" && data.results?.length) {
  //     return data.results[0].formatted_address;
  //   } else {
  //     return null;
  //   }
  //   // if (data.status === "OK") {
  //   //   return data.results[0].formatted_address;
  //   // } else {
  //   //   return null;
  //   // }
  // }

  async addGeofenceDrawing(data) {
    try {
      const postData = { geosetting: data };
      const postDataJSONString = JSON.stringify(postData);
      const base64Input = btoa(
        unescape(encodeURIComponent(postDataJSONString))
      );
      if (config.pythonReport == 1) {
        var response = await postApi
          .getClient("")
          .post(
            config.NodeUrl + "/liveTracking/createUpdateGeofence",
            postData
          );
      } else {
        const encodedBase64Input = encodeURIComponent(base64Input);
        var response = await postApi
          .getClient()
          .post(
            "index.php?c=geofence&a=update",
            "postData=" + encodedBase64Input
          );
      }

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  async getstopidle(data) {
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=trip&a=getstopidle", "postData=" + base64Input);

    this.stopIdleArray = response.data.data.StopIdleData;
  }

  async getGofenceList({ companyId, searchField, offset, limit }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      searchField: searchField ? searchField : "",
      offset,
      limit,
    };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/taxi/geoData", { params: postData });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=geofence&a=geoData", "postData=" + base64Input);
    }

    this.geofenceListArray = response?.data.data.geofence;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
    return response?.data.data.geofence;
  }
  setAutorunPopup(data) {
    this.AutorunPopup = data;
  }

  async deleteGeofence(data) {
    var postData = { geosetting: data };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=geofence&a=delete", "postData=" + base64Input);

    return response;
  }

  setMarker(data) {
    this.Marker = data;
  }
  getIcon(data) {
    var r = data;
    var lastReportingTime = r.updatedate;
    // var serverCurrentTime = r.currtime ;
    var serverCurrentTime = r.currtime;
    var diff = new Date(serverCurrentTime) - new Date(lastReportingTime);

    diff /= 60000; //diff convert in minutes.

    if (
      r.vehicleTypeNew == "Truck" ||
      r.vehicleTypeNew == "Trailer" ||
      r.vehicleTypeNew == "Reefer" ||
      r.vehicleTypeNew == "Generator"
    ) {
      //for truck

      if (diff >= 90) {
        return require("../assets/images/livetracking/Truck-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Truck-yellow.png");
      } else if (r.acc == 0) {
        //stopped
        return require("../assets/images/livetracking/Truck-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Truck-green.png");
      }
    } else if (
      r.vehicleTypeNew == "SchoolBus" ||
      r.vehicleTypeNew == "Mini Bus" ||
      r.vehicleTypeNew == "Tourist Bus"
    ) {
      //for SchoolBus

      if (diff >= 90) {
        return require("../assets/images/livetracking/Mini-Bus-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        // return FLEET_SERVER_URL + "images/vehicles/bus-icon-yellow.png";
        return require("../assets/images/livetracking/Mini-Bus-yellow.png");
      } else if (r.acc == 0) {
        //stopped
        // return FLEET_SERVER_URL + "images/vehicles/bus-icon-red.png";
        return require("../assets/images/livetracking/Mini-Bus-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        // return FLEET_SERVER_URL + "images/vehicles/bus-icon-green.png";
        return require("../assets/images/livetracking/Mini-Bus-green.png");
      }
    } else if (r.vehicleTypeNew == "Car") {
      //for car

      if (diff >= 90) {
        return require("../assets/images/livetracking/Car-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Car-yellow.png");
      } else if (r.acc == 0) {
        //stopped
        return require("../assets/images/livetracking/Car-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Car-green.png");
      }
    } else if (
      r.vehicleTypeNew == "PickUp" ||
      r.vehicleTypeNew == "3Ton PickUp" ||
      r.vehicleTypeNew == "5Ton PickUp" ||
      r.vehicleTypeNew == "10Ton PickUp" ||
      r.vehicleTypeNew == "Hilux" ||
      r.vehicleTypeNew == "Bobcat" ||
      r.vehicleTypeNew == "Canter" ||
      r.vehicleTypeNew == "Machine"
    ) {
      if (diff >= 90) {
        return require("../assets/images/livetracking/PickUp-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/PickUp-yellow.png");
      } else if (r.acc == 0) {
        //stopped
        return require("../assets/images/livetracking/PickUp-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/PickUp-green.png");
      }
    } else if (
      r.vehicleTypeNew == "Van" ||
      r.vehicleTypeNew == "Hiace" ||
      r.vehicleTypeNew == "Urvan" ||
      r.vehicleTypeNew == "Tanker"
    ) {
      if (diff >= 90) {
        return require("../assets/images/livetracking/Van-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Van-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Van-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Van-green.png");
      }
    } else if (r.vehicleTypeNew == "Crane") {
      //for Crane

      if (diff >= 90) {
        return require("../assets/images/livetracking/Crane-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Crane-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Crane-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Crane-green.png");
      }
    } else if (r.vehicleTypeNew == "Bulldozer") {
      //for Bulldozer

      if (diff >= 90) {
        return require("../assets/images/livetracking/Bulldozer-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Bulldozer-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Bulldozer-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Bulldozer-green.png");
      }
    } else if (r.vehicleTypeNew == "Dumper") {
      //for JCB

      if (diff >= 90) {
        return require("../assets/images/livetracking/Dumper-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Dumper-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Dumper-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Dumper-green.png");
      }
    } else if (r.vehicleTypeNew == "Excavator") {
      //for Excavator

      if (diff >= 90) {
        return require("../assets/images/livetracking/Excavator-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Excavator-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Excavator-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Excavator-green.png");
      }
    } else if (r.vehicleTypeNew == "Forklif") {
      //for Forklif

      if (diff >= 90) {
        return require("../assets/images/livetracking/Forklif-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Forklif-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Forklif-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Forklif-green.png");
      }
    } else if (r.vehicleTypeNew == "Bobcat") {
      //for Bobcat
    } else if (r.vehicleTypeNew == "Roller") {
      //for Bobcat

      if (diff >= 90) {
        return require("../assets/images/livetracking/Roller-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Roller-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Roller-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Roller-green.png");
      }
    }
    // else if (r.vehicleTypeNew == "Canter") {//for canter

    //     if (diff >= 90) {
    //         return '<img src="public/fleet/images/detailtracking/canter-gray-icon.png" height="16px" width="30px" />&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.acc == 1 && r.speed == 0) {//idle
    //         return '<img src="public/fleet/images/detailtracking/canter-yellow-icon.png" height="16px" width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.acc == 0 || r.acc == null) {//stopped
    //         return '<img src="public/fleet/images/detailtracking/canter-red-icon.png" height="16px" width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.acc == 1 && r.speed > 0) {//running
    //         return '<img src="public/fleet/images/detailtracking/canter-green-icon.png" height="16px"  width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    // }
    else if (
      r.vehicleTypeNew == "Boom Loader" ||
      r.vehicleTypeNew == "Shovel"
    ) {
      //for  Boom Loader

      if (diff >= 90) {
        return require("../assets/images/livetracking/Boom-Loader-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Boom-Loader-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Boom-Loader-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Boom-Loader-green.png");
      }
    }
    // else if (r.vehicleTypeNew == "Generator") {//for  Generator

    //     if (diff >= 90) {
    //         return '<img src="public/fleet/images/detailtracking/generator-gray-icon.png" height="16px" width="30px" />&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.acc == 1 && r.speed == 0) {//idle
    //         return '<img src="public/fleet/images/detailtracking/generator-yellow-icon.png" height="16px" width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.acc == 0 || r.acc == null) {//stopped
    //         return '<img src="public/fleet/images/detailtracking/generator-red-icon.png" height="16px" width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.acc == 1 && r.speed > 0) {//running
    //         return '<img src="public/fleet/images/detailtracking/generator-green-icon.png" height="16px"  width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    // }
    // else if (r.vehicleTypeNew == "Machine") {//for  Machine

    //     if (diff >= 90) {
    //         return '<img src="public/fleet/images/detailtracking/machine-gray-icon.png" height="16px" width="30px" />&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.get('acc') == 1 && r.get('speed') == 0) {//idle
    //         return '<img src="public/fleet/images/detailtracking/machine-yellow-icon.png" height="16px" width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.get('acc') == 0 || r.get('acc') == null) {//stopped
    //         return '<img src="public/fleet/images/detailtracking/machine-red-icon.png" height="16px" width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    //     else if (r.get('acc') == 1 && r.get('speed') > 0) {//running
    //         return '<img src="public/fleet/images/detailtracking/machine-green-icon.png" height="16px"  width="30px"/>&nbsp' + r.get('vehicleNo');
    //     }
    // }
    else if (r.vehicleTypeNew == "JCB") {
      //for  JCB

      if (diff >= 90) {
        return require("../assets/images/livetracking/JCB-gray.png");
      } else if (r.acc == 1 && r.get("speed") == 0) {
        //idle
        return require("../assets/images/livetracking/JCB-yellow.png");
      } else if (r.acc == 0 || r.get("acc") == null) {
        //stopped
        return require("../assets/images/livetracking/JCB-red.png");
      } else if (r.acc == 1 && r.get("speed") > 0) {
        //running
        return require("../assets/images/livetracking/JCB-green.png");
      }
    } else if (r.vehicleTypeNew == "Motorcycle") {
      //for  Motorcycle

      if (diff >= 90) {
        return require("../assets/images/livetracking/Motorcycle-gray.png");
      } else if (r.acc == 1 && r.speed == 0) {
        //idle
        return require("../assets/images/livetracking/Motorcycle-yellow.png");
      } else if (r.acc == 0 || r.acc == null) {
        //stopped
        return require("../assets/images/livetracking/Motorcycle-red.png");
      } else if (r.acc == 1 && r.speed > 0) {
        //running
        return require("../assets/images/livetracking/Motorcycle-green.png");
      }
    }
  }

  async sampleExcel() {
    window.location.href = window.location.href =
      config.fleetURL + "/appRes/excel/geofencesample1.xlsx";
  }

  async samplePoiExcel() {
    window.location.href = window.location.href =
      config.fleetURL + "/appRes/excel/poi.xlsx";
  }

  async addGeofenceByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/liveTracking/importGeofence", postData);
    }
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=geofence&a=uploadGeofenceExcel",
        "postData=" + base64Input
      );
    this.excelLoadig = false;
    return response.data;
  }

  async daySummary({ currentDate, companyId, vehicleId }) {
    var postData = {
      pollmin: 90,
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: currentDate,
      toDate: currentDate,
      offset: 0,
      limit: 50,
      dateType: 1,
    };
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("fleet_report/fleetDaySummary", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=daysummary", "postData=" + base64Input);
    }

    this.daySummaryObj = response.data?.data?.daysummary[0];

    return response?.data?.data?.daysummary[0];
  }

  // async getTypeData({ latlong, type }) {
  //   const apiUrl = `https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=${
  //     latlong[0]
  //   },${
  //     latlong[1]
  //   }&radius=5000&type=${type}&key=${"AIzaSyAYh_6XQRV70kMX2LdZ9B1fd4qOhTgvfIo"}`;

  //   try {
  //     const response = await axios.get(apiUrl);

  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     throw error;
  //   }
  // }

  // async getTypeData({ latlong, type }) {
  //   console.log(latlong, "latlong")
  //   // const apiUrl = `https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=${latlong[0]},${latlong[1]}&radius=5000&type=${type}&key=${config.googleMapKey}`;
  //   const [lat, lng] = latlong;
  //   // console.log(apiUrl, "apiUrl")

  //   console.log(window.google.maps.places.PlacesServiceStatus);
  //   const location = new window.google.maps.LatLng(Number(lat), Number(lng));
  //   console.log(location, "location")

  //   console.log("Lat:", location.lat());
  //   console.log("Lng:", location.lng());
  //   // try {
  //   //   let lat = latlong[0],
  //   //     lng = latlong[1];
  //   //   const data = { lat, lng, type: type };
  //   //   // const response = await axios.get(apiUrl);
  //   //   var response = await postApi
  //   //     .getClient("")
  //   //     .get(config.NodeUrl + "/liveTracking/getNearbyPlaces", {
  //   //       params: data,
  //   //     });
  //   //   return response.data;
  //   // } catch (error) {
  //   //   console.error("Error fetching data:", error);
  //   //   throw error;
  //   // }
  // }
  getTypeData = ({ latlong, type }) => {
    return new Promise((resolve, reject) => {
      if (!window.google?.maps?.places) {
        return reject("Google Maps Places API not loaded");
      }

      const [lat, lng] = latlong;
      const location = new window.google.maps.LatLng(lat, lng);

      const hiddenDiv = document.createElement("div");
      hiddenDiv.style.width = "1px";
      hiddenDiv.style.height = "1px";
      document.body.appendChild(hiddenDiv);

      // ✅ MUST create Google Map
      const googleMap = new window.google.maps.Map(hiddenDiv, {
        center: location,
        zoom: 15,
      });

      console.log(googleMap, "googleMap")
      const service = new window.google.maps.places.PlacesService(googleMap);

      const request = {
        location,
        radius: 5000,
        type: type,
      };

      service.nearbySearch(request, (results, status) => {
        console.log("STATUS:", status);

        document.body.removeChild(hiddenDiv);

        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          resolve(results);
        } else {
          console.error("Places search failed:", status);
          resolve([]);
        }
      });
    });
  };
  exportPoiVehicle(vehicleId) {
    window.location.href =
      config.baseURL +
      "index.php?c=poi&a=exportpoivehicle&vid=" +
      vehicleId.join(",") +
      "&zoneIds=";
  }

  async getLocationUrl(vehicleId) {
    var postData = vehicleId;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=liveLocation&a=getVehicleId",
        "postData=" + base64Input
      );

    return response?.data?.data;
  }

  async addLiveLocation(liveLocationData) {
    var postData = liveLocationData;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=liveLocation&a=update", "postData=" + base64Input);

    return response;
  }

  async getVehiclePositionofVehicle({ vehicleId, companyId, isadmin, userId }) {
    var postData = {
      tokenId: "",
      vehicleId: vehicleId,
      userId: userId,
      isadmin: isadmin,
      companyId: companyId,
      refreshduration: "30",
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicle&a=getvehicleposition",
        "postData=" + base64Input
      );
    this.vehiclePositionData = response.data.data?.vehicleposition;

    return this.vehiclePositionData;
  }

  async getAlertCounts({ companyId, fromDate, toDate }) {
    var postData = {
      companyId: companyId,
      ruleSelectorId: [
        "1",
        "2",
        "5",
        "6",
        "4",
        "7",
        "10",
        "8",
        "15",
        "16",
        "18",
        "23",
        "25",
        "24",
        "26",
        "27",
        "28",
        "29",
        "30",
      ],
      fromDate: fromDate,
      toDate: toDate,
    };
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/ruleTrigger/ruleTriggerAlertCount", postData);
    this.alertsData = response.data.data?.vehicleData;
    this.alertsTotalCount = response?.data.data?.TotalCount;
    return response;
  }

  async getMaintenanceCounts({ companyId, userId, isadmin }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/maintenanceDashboard/getVehicleWiseCount", {
        params: postData,
      });
    this.maintenanceData = response?.data?.data?.maintenancereport;
    this.maintenanceTotalCount = response?.data?.data?.TotalCount;
    return response;
  }

  async getAllDeviceGroups({ companyId }) {
    var postData = {
      companyId: companyId,
    };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/deviceGroup/getAllGroups", {
        params: postData,
      });

    // var response = await postApi
    //   .getClient()
    //   .get("http://localhost:3034/deviceGroup/getAllGroups", {
    //     params: postData,
    //   });
    this.deviceGroupList = response?.data?.data;

    return response;
  }

  async getAllVehicles(companyId) {
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    let userCompanyId = JSON.parse(
      base64_decode(Cookies.get("data"))
    ).userCompanyId;

    let userId = JSON.parse(base64_decode(Cookies.get("data"))).userId;
    let response
    if (config.pythonReport === 1) {
      response = await postApi
        .getClient()
        .get(config.NodeUrl + "/liveTracking/getAllLiveTrackingVehiclesCH", {
          params: {
            companyId: isadmin == 1 || 0 ? userCompanyId : companyId,
            userId: userId,
            isadmin: isadmin,
          },
        });
    } else {
      response = await postApi
        .getClient()
        .get(config.NodeUrl + "/liveTracking/getAllLiveTrackingVehicles", {
          params: {
            companyId: isadmin == 1 || 0 ? userCompanyId : companyId,
            userId: userId,
            isadmin: isadmin,
          },
        });
    }



    let liveTrackingData = response?.data?.data?.livetrack;


    let finalLiveTrackingData = await this.handleVehicleImage(liveTrackingData);

    this.plotAllVehicles = finalLiveTrackingData;

    return response;
  }

  async showAllPois(companyId) {
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/pointOfInterest/getPoi", {
        params: {
          companyId: companyId
        }
      });

    this.poiData = response?.data?.response
    return response?.data?.response
  }

  async searchPoiData(companyId, poiId) {
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/pointOfInterest/getsearchPoi", {
        params: {
          companyId: companyId,
          poiId: poiId
        }
      });

    return response?.data?.response
  }

  async addPoiData(data) {

    var response = await postApi.getClient("").post(config.NodeUrl + "/pointOfInterest/createPoi", data);
    return response
  }

  async deletePoiData(poiId) {
    console.log(poiId)
    var response = await postApi.getClient("").delete(config.NodeUrl + "/pointOfInterest/deleteLiveTrackingPoi", { params: { poiId: poiId } });
    return response
  }

  async addPOIByExcel(data) {
    this.excelLoadig = true;


    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/pointOfInterest/importPoiData", data);
    this.excelLoadig = false;
    return response.data;
  }

}
export default LiveTrackingStore;
